// src/components/SupportPage.js (Complete Modified Code)
import React, { useState } from 'react';
import './SupportPage.css';

const SupportPage = () => {
  // Define your FAQ data here
  const allFaqs = [
    {
      id: 1,
      question: "📝 How do I create a profile?",
      answer: "To create a profile, simply download the RoomEase app, sign up using your email or phone number, and then fill in your details. Don't forget to include your preferences so we can help you find your ideal roommate!"
    },
    {
      id: 2,
      question: "🤝 How does RoomEase match me with a roommate?",
      answer: "RoomEase uses a smart algorithm that considers your preferences, lifestyle choices, and location to suggest potential roommates who genuinely align with your needs."
    },
    {
      id: 3,
      question: "✍️ Can I edit my profile details later?",
      answer: "Absolutely! You can update your profile details at any time from the settings section within the RoomEase app."
    },
    {
      id: 4,
      question: "💬 How do I contact a potential roommate?",
      answer: "Once you find a match you're interested in, you can easily start a conversation directly through our secure in-app chat feature."
    },
    {
      id: 5,
      question: "🗑️ How do I delete my RoomEase account?",
      // The 'answer' here is now a plain string for searching
      answer: "To delete your account, please follow these simple steps within the app: Go to your Profile -> Tap on Account Settings -> Select Delete Account and follow the prompts. Data Deletion: All personal information, viewing history, and payment information will be permanently deleted. Some data may be retained for legal or regulatory purposes, such as transaction records, for up to 30 days after account deletion. For more information, please refer to our Privacy Policy.",
      // Add a separate property to store the JSX for rendering
      renderAnswer: (
        <>
          To delete your account, please follow these simple steps within the app:
          <br />
          <ul>
            <li>- Go to your Profile</li>
            <li>- Tap on Account Settings</li>
            <li>- Select Delete Account and follow the prompts</li>
          </ul>
          <br />
          <strong>Data Deletion:</strong>
          <ul>
            <li><u>Deleted Data:</u> All personal information, viewing history, and payment information will be permanently deleted.</li>
            <li><u>Retained Data:</u> Some data may be retained for legal or regulatory purposes, such as transaction records, for up to 30 days after account deletion.<br/>For more information, please refer to our <a href="/privacy-policy">Privacy Policy</a>.</li>
          </ul>
        </>
      )
    },
    {
      id: 6,
      question: "💲 Is RoomEase free to use?",
      answer: "Yes, creating a profile, searching for roommates, and chatting are all free! We may introduce premium features in the future."
    },
    {
      id: 7,
      question: "🤷 What if I can't find a match?",
      answer: "If you're having trouble finding a match, try broadening your preferences or reach out to our support team for personalized tips!"
    },
    {
      id: 8,
      question: "📍 Is RoomEase available in my city or specific locations?",
      answer: "RoomEase is designed to work across all of India! While we're bustling with activity and finding lots of matches in Mumbai, Delhi, and Bangalore, we're also seeing wonderful new connections forming in Pune and Chandigarh/Mohali. Feel free to download and use the app in any city, just keep in mind that the number of available profiles can vary by location. We're always growing!"
    },
    {
      id: 9,
      question: "🚀 When did RoomEase launch and who are its founders?",
      answer: "RoomEase officially launched on May 1st, 2025! Our founders are Vriddhi Arora and Kushagra Arora. We're a young, budding startup incredibly excited about helping you find your perfect roommate as we continue to grow!"
    },
    {
      id: 10,
      question: "👫 Can I request a roommate of a specific gender?",
      answer: "Yes, ofcourse! We understand how important preferences are. RoomEase is built with smart algorithms and features that allow you to easily add various filters, including specific gender preferences. You'll then only see profiles that perfectly align with your chosen criteria, making your search smoother!"
    }
  ];

  // State to manage the search input value
  const [searchTerm, setSearchTerm] = useState('');

  // Filter FAQs based on the search term
  const filteredFaqs = allFaqs.filter(faq =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    // Use the plain 'answer' property for filtering
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="support-page-container">
      {/* Hero Section */}
      <section className="support-hero">
        <div className="container">
          <h1 className="hero-title">Hey there, how can we help?</h1>
          <p className="hero-subtitle">
            Find answers to your questions, explore helpful guides, and connect with us.
          </p>
          {/* Functional Search Bar */}
          <input
            type="text"
            placeholder="🔍 Search for an answer..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </section>

      {/* Main FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-heading">Frequently Asked Questions</h2>
          <div className="faq-grid">
            {filteredFaqs.length > 0 ? (
              filteredFaqs.map(faq => (
                <div className="faq-item" key={faq.id}>
                  <h4>{faq.question}</h4>
                  {/* Use the new 'renderAnswer' property for display if it exists, otherwise use 'answer' */}
                  <div>{faq.renderAnswer ? faq.renderAnswer : faq.answer}</div>
                </div>
              ))
            ) : (
              <p className="no-results">No FAQs found matching your search. Try a different keyword!</p>
            )}
          </div>
        </div>
      </section>

      {/* Need Further Assistance Section */}
      <section className="further-assistance-section">
        <div className="container">
          <h2 className="section-heading">Can't find what you're looking for?</h2>
          <p className="sub-heading">
            We are just an email away to help you out!
          </p>
          <p className="contact-email">
            <a href="mailto:support@roomease.co.in" className="email-button">
                📧 support@roomease.co.in
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default SupportPage;